import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["pendingTab", "finishedTab", "pendingList", "finishedList"]

  connect() {
    // Initialize Lucide icons
    if (window.lucide) {
      window.lucide.createIcons()
    }
  }

  showPending() {
    // Update tabs
    this.pendingTabTarget.classList.remove("border-transparent", "text-gray-500")
    this.pendingTabTarget.classList.add("border-primary-500", "text-primary-600")
    this.finishedTabTarget.classList.remove("border-primary-500", "text-primary-600")
    this.finishedTabTarget.classList.add("border-transparent", "text-gray-500")

    // Show/hide lists
    this.pendingListTarget.classList.remove("hidden")
    this.finishedListTarget.classList.add("hidden")
  }

  showFinished() {
    // Update tabs
    this.finishedTabTarget.classList.remove("border-transparent", "text-gray-500")
    this.finishedTabTarget.classList.add("border-primary-500", "text-primary-600")
    this.pendingTabTarget.classList.remove("border-primary-500", "text-primary-600")
    this.pendingTabTarget.classList.add("border-transparent", "text-gray-500")

    // Show/hide lists
    this.finishedListTarget.classList.remove("hidden")
    this.pendingListTarget.classList.add("hidden")
  }

  toggleCard(event) {
    const header = event.currentTarget
    const cardTarget = header.dataset.cardTarget
    const content = document.getElementById(cardTarget)
    const indicator = header.querySelector("[data-collapse-indicator] i")

    if (content) {
      content.classList.toggle("hidden")

      // Update icon
      if (indicator) {
        const isExpanded = !content.classList.contains("hidden")
        indicator.setAttribute("data-lucide", isExpanded ? "chevron-down" : "chevron-right")
        if (window.lucide) {
          window.lucide.createIcons()
        }
      }
    }
  }
}
